function SelectForm({ label, name, options, value, onChange, multiple = false }) {
    return (
        <div>
            <label htmlFor={name} className="block text-sm font-medium text-foreground/80 mb-1.5">{label}</label>
            <select
                name={name}
                id={name}
                multiple={multiple}
                value={value}
                onChange={onChange}
                className="w-full h-9 px-3 text-sm border border-input rounded-md bg-card text-foreground outline-none focus:ring-2 focus:ring-primary/15 focus:border-primary transition-all duration-150"
            >
                {options.map((opt, idx) => (
                    <option key={idx} value={opt}>{opt}</option>
                ))}
            </select>
        </div>
    );
}

export default SelectForm;
